import { apiClient } from './client';

export interface VCollectSubmission {
  id: number; submission_reference: string; form_version_id: number; odk_instance_id: string;
  enumerator_id: number | null; enumerator_name: string | null; submitted_at: string | null; received_at: string; review_status: string;
  form_title?: string; vcollect_project_id?: number;
}
export interface VCollectSubmissionDetail extends VCollectSubmission { raw_xml: string; odk_submitter_id: number | null; }
export interface VCollectSubmissionReview { id: number; decision: string; comment: string | null; reviewed_by: number; reviewed_at: string; }
export interface VCollectQualityFlag { id: number; rule_type: string; message: string; detected_at: string; resolved: number; }

export const SUBMISSION_STATUS_LABELS: Record<string, string> = {
  received: 'Received', pending_review: 'Pending Review', flagged: 'Flagged', under_review: 'Under Review',
  verified: 'Verified', returned: 'Returned', invalidated: 'Invalidated',
};

export const vcollectSubmissionsApi = {
  list: (filters: { formVersionId?: number; vcollectProjectId?: number; reviewStatus?: string } = {}) => {
    const params = new URLSearchParams(Object.entries(filters).filter(([, v]) => v).map(([k, v]) => [k, String(v)]));
    return apiClient.get<{ data: VCollectSubmission[] }>(`/api/vcollect-submissions${params.toString() ? `?${params}` : ''}`);
  },
  get: (id: number) => apiClient.get<{ data: VCollectSubmissionDetail }>(`/api/vcollect-submissions/${id}`),
  listReviews: (id: number) => apiClient.get<{ data: VCollectSubmissionReview[] }>(`/api/vcollect-submissions/${id}/reviews`),
  listQualityFlags: (id: number) => apiClient.get<{ data: VCollectQualityFlag[] }>(`/api/vcollect-submissions/${id}/quality-flags`),
  resolveQualityFlag: (flagId: number) => apiClient.put<{ data: { resolved: boolean } }>(`/api/vcollect-quality-flags/${flagId}/resolve`, {}),
  review: (id: number, decision: string, comment?: string) => apiClient.post<{ data: { id: number; status: string } }>(`/api/vcollect-submissions/${id}/review`, { decision, comment }),
  sync: (versionId: number) => apiClient.post<{ data: { newCount: number; skippedCount: number; errors: string[] } }>(`/api/vcollect-form-versions/${versionId}/sync-submissions`, {}),
};
